export default __webpack_public_path__ + "static/media/Logo.595b8b63.svg";